/** Email field copy shared by the login and recovery screens. */
export const REQUIRED_EMAIL_MESSAGE = 'Ingresa tu correo para continuar.';
export const INVALID_EMAIL_MESSAGE = 'Ingresa un correo válido.';
